/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";

const optionGroupComponentName = "universal-filter-option-group-filtered-scroll-area";

const accordionScrollAreaInputSelector =
    ".universal-filter-option-group-filtered-scroll-area__input";
const accordionSectionSelector = ".universal-filters__filter-section-accordion-title";

export default baustein.register("universal-filters-accordion-section", {
    setupEvents(add) {
        add(
            "click",
            `${accordionScrollAreaInputSelector}, ${accordionSectionSelector}`,
            this.onAccordionSectionClick
        );
    },

    onAccordionSectionClick() {
        const optionGroupComponent = this.findComponent(optionGroupComponentName);

        if (optionGroupComponent && optionGroupComponent.options.lazyLoaded) {
            optionGroupComponent.fetchOptionGroup();
        }
    }
});

